<script>
import GlobalVue from '@helper/Global.vue';
import BOGen from '@helper/BOGen';

export default {
  extends: GlobalVue,
  data(){
    return {
      havePermission: true,
    }
  },
  mounted(){
    if(BOGen.notLogin()){
      return this.havePermission = false
    }
    this.refreshVariable()
  }
}
</script>

<template>
  <div>
    <div v-if="havePermission">
      <FileManager inline></FileManager>
      <ImageFilter></ImageFilter>
    </div>
    <h3 class="tc" v-else>You don't have permission</h3>
  </div>
</template>
